import { Component, Inject, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

export interface ConfirmData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
}

@Component({
  selector: 'app-modals-confirm',
  imports: [MatDialogActions, MatDialogTitle, MatDialogContent, MatButtonModule, TranslateModule],
  standalone: true,
  templateUrl: './modals-confirm.component.html',
  styleUrl: './modals-confirm.component.scss'
})
export class ModalsConfirmComponent {

  private dialogRef: MatDialogRef<ModalsConfirmComponent, boolean> = inject(MatDialogRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmData) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

}
